module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_maedori_01@2x-fa89d8f5e3b1955e5eff7aa6a7944d58.webp";